// extracted by mini-css-extract-plugin
export var container = "_5u-0";
export var fallback = "_5u-5";
export var fallbackIcon = "_5u-6";
export var hidden = "_5u-2";
export var image = "_5u-3";
export var loaded = "_5u-4";
export var placeholder = "_5u-1";